import axios from 'axios';

// Public APIs
const instance = axios.create({
   baseURL: process.env.API_HOST,
});

// Admin APIs
const instanceAdmin = axios.create({
   baseURL: process.env.API_HOST,
});
instanceAdmin.interceptors.request.use(config => {
   const token = localStorage.getItem('fc-token');
   let userInfo = localStorage.getItem('fc-user');
   try {
      userInfo = JSON.parse(userInfo);
   } catch (error) {
      userInfo = {};
   }
   config.headers.Authorization = token ? `Bearer ${token}` : '';
   config.data = {
      ...config.data,
      userName: (userInfo && userInfo.name) || '',
   };
   return config;
});

// DB insert APIs
const instanceDB = axios.create({
   baseURL: `${process.env.API_HOST}/db/processdata/`,
});

instanceDB.interceptors.request.use(config => config);

export default {
   get: (endPoint, payload = {}) => instance.get(endPoint, payload),
   post: (endPoint, payload = {}) => instance.post(endPoint, payload),
   getAdmin: (endPoint, payload = {}) => instanceAdmin.get(endPoint, payload),
   putAdmin: (endPoint, payload = {}) => instanceAdmin.put(endPoint, payload),
   postAdmin: (endPoint, payload = {}) => instanceAdmin.post(endPoint, payload),
   postDB: (endPoint, payload = {}) => instanceDB.post(endPoint, payload),
};
